<template>
  <div class="card-container">
    <div class="head">
      <div v-if="title" class="title">{{ title }}</div>
      <slot v-else name="header"></slot>
    </div>
    <div class="main">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
// import { defineProps } from 'vue';

// defineProps<{
//   title?: string
// }>();

export default {
  name: 'SubsCard',
  props: {
    /**
     * 空态图标
     */
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  padding: 24px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #EFEFF4;
}
.head {
  width: 100%;
  padding-bottom: 17px;
  border-bottom: 1px solid #EFEFF4;
  .title {
    font-family: OPPOSans, OPPOSans;
    font-weight: bold;
    font-size: 20px;
    color: #1A202C;
    line-height: 30px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.main {
  margin-top: 24px;
}
</style>
